import { createPublicClient, defineChain, http } from "viem";

import { publicEnvironment } from "./public-env";

const ROBINHOOD_MAINNET_CHAIN_ID = 4_663;
const ROBINHOOD_TESTNET_CHAIN_ID = 46_630;
const configuredChainId = Number(
  publicEnvironment("VITE_CHAIN_ID") || ROBINHOOD_MAINNET_CHAIN_ID,
);
if (
  configuredChainId !== ROBINHOOD_MAINNET_CHAIN_ID &&
  configuredChainId !== ROBINHOOD_TESTNET_CHAIN_ID
) {
  throw new Error("VITE_CHAIN_ID must be 4663 or 46630.");
}

const mainnet = configuredChainId === ROBINHOOD_MAINNET_CHAIN_ID;
const defaultRpcUrl = mainnet
  ? "https://rpc.mainnet.chain.robinhood.com"
  : "https://rpc.testnet.chain.robinhood.com";

export const targetChain = defineChain({
  id: configuredChainId,
  name: mainnet ? "Robinhood Chain" : "Robinhood Chain Testnet",
  nativeCurrency: { name: "Ether", symbol: "ETH", decimals: 18 },
  rpcUrls: {
    default: { http: [defaultRpcUrl] },
  },
  blockExplorers: {
    default: {
      name: "Blockscout",
      url: mainnet
        ? "https://robinhoodchain.blockscout.com"
        : "https://explorer.testnet.chain.robinhood.com",
    },
  },
  testnet: !mainnet,
});

export const publicClient = createPublicClient({
  chain: targetChain,
  transport: http(
    (typeof process === "undefined" ? undefined : process.env.CHAIN_RPC_URL) ||
      publicEnvironment("VITE_CHAIN_RPC_URL") ||
      defaultRpcUrl,
  ),
});

export const ROBINHOOD_CHAIN_IDS = [
  ROBINHOOD_MAINNET_CHAIN_ID,
  ROBINHOOD_TESTNET_CHAIN_ID,
] as const;
